import type { ConnectionChannel } from "@/server/types/api";

/**
 * How each acquisition channel reads in the UI. Only `patient_access` occurs
 * today; the others are labelled now so a network or backend integration shows
 * correct provenance the day it starts writing connections.
 */
export const CONNECTION_CHANNEL_LABEL: Record<ConnectionChannel, string> = {
  patient_access: "Patient access",
  health_information_exchange: "Health information exchange",
  direct_integration: "Direct integration",
};

/** Badge tones per channel, so provenance is distinguishable at a glance. */
export const CONNECTION_CHANNEL_TONE: Record<ConnectionChannel, string> = {
  patient_access: "bg-blue-500/10 text-blue-700 dark:text-blue-300",
  health_information_exchange: "bg-violet-500/10 text-violet-700 dark:text-violet-300",
  direct_integration: "bg-teal-500/10 text-teal-700 dark:text-teal-300",
};

/**
 * Reader-facing label for a connection's lifecycle state. `refresh_failed` and
 * `expired` both mean the same thing to the person reading it — the patient
 * has to sign in again — so they say so rather than naming the mechanism.
 */
export const CONNECTION_STATUS_LABEL: Record<string, string> = {
  active: "Active",
  failed: "Sign-in failed",
  expired: "Sign-in expired",
  refresh_failed: "Sign-in expired",
  disconnected: "Disconnected",
};
